module.exports = __webpack_public_path__ + "img/asset-v2.9e607bd4.svg";